import { render, staticRenderFns } from "./CheckLimit.vue?vue&type=template&id=82a749ce&scoped=true&"
import script from "./CheckLimit.vue?vue&type=script&lang=ts&"
export * from "./CheckLimit.vue?vue&type=script&lang=ts&"
import style0 from "./CheckLimit.vue?vue&type=style&index=0&id=82a749ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a749ce",
  null
  
)

export default component.exports